// Açılış düşüşü (World/index.js reveal.go → uRevealProgress 0 → 1): her nesne, merkezinin araba başlangıcına
// (0, 0) uzaklığına göre sırası gelince 14 m yukarıdan yerçekimi gibi hızlanarak düşer ve bir kez hafifçe seker;
// dalga arabadan dışarı yayılır. Yalnız görüntü: fizik gövdeleri yerinde kalır (domino / yığın kurulumları bozulmaz).
// aReveal: w = 0 → birleştirilmiş sabit geometri, xy = nesne merkezi (Objects.js merge)
//          w = 1 → öznitelik yok (varsayılan) → modelMatrix konumu
//          w = 2 → düşmez (araba: kendisi fizikle 12 m'den düşer)
uniform float uRevealProgress;
attribute vec4 aReveal;

float revealHeight(float _t)
{
    if(_t < 0.72)
    {
        float k = _t / 0.72;
        return 1.0 - k * k;
    }
    float k = (_t - 0.72) / 0.28;
    return 0.06 * sin(k * 3.14159265) * (1.0 - k * 0.3);
}

float revealOffset(vec4 _reveal, mat4 _modelMatrix)
{
    if(_reveal.w > 1.5)
    {
        return 0.0;
    }
    vec2 origin = _reveal.w > 0.5 ? (_modelMatrix * vec4(0.0, 0.0, 0.0, 1.0)).xy : _reveal.xy;
    float start = min(length(origin) / 140.0, 0.7);
    float fall = clamp((uRevealProgress - start) / 0.3, 0.0, 1.0);
    return 14.0 * revealHeight(fall);
}
